(async () => {
  const el = document.getElementById('memory-board-page')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/memorial/index.vue'),
    },
  ]

  await clientRender({ components })
})()
